import { Button, buttonStyle } from '@florencelabs/button';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';
import {
  formatPhone,
  phoneToTelUri,
} from '@provider-directory/components/phone-number';
import { useSearch } from '@provider-directory/contexts/ProviderSearchContext';
import { useTrackAndOpenCall } from '@provider-directory/hooks/useTrackAndOpenCall';

export const EmptyStateGeneric = (): ReactElement => {
  const { t } = useTranslation();
  const {
    config: { name: orgName, scheduling },
  } = useOrgContext();
  const { clearFiltersKeepScope } = useSearch();
  const trackAndOpenCall = useTrackAndOpenCall();

  const formattedPhone = formatPhone(scheduling.displayNumber, {
    format: 'abridged',
  });

  return (
    <>
      <div className={'flex w-full flex-col items-center gap-1 text-center'}>
        <span className={'text-body-xlarge-semibold'}>
          {t('searchResults.noResultsTitle')}
        </span>
        <p className={'max-w-prose text-body-medium'}>
          {t('searchResults.noResultsBody')}
        </p>
      </div>
      <div className={'flex flex-wrap items-center justify-center gap-2.5'}>
        <a
          href={phoneToTelUri(scheduling.phoneNumber)}
          className={buttonStyle({ variant: 'clientMain', size: 'small' })}
          aria-label={t('aria.callLocation', {
            locationName: orgName,
          })}
          rel={'noopener noreferrer'}
          onClick={trackAndOpenCall(scheduling.phoneNumber)}
        >
          {formattedPhone}
        </a>
        <Button
          testId={'empty-state-clear-filters-btn'}
          type={'button'}
          variant={'systemOutline'}
          size={'small'}
          onPress={clearFiltersKeepScope}
        >
          {t('searchFilters.clear')}
        </Button>
      </div>
    </>
  );
};
